import { boardsApi } from '../../../api';
import type { InviteParticipantResponse } from '../../../types';

export const createInviteParticipant = () => {
  return async (id: string, email: string, options?: { message?: string; forceResend?: boolean }): Promise<InviteParticipantResponse> => {
    return boardsApi.inviteParticipant(id, email, options);
  };
};
